import * as React from 'react'

import { TextField, TextFieldProps } from '@mui/material'
import { NumericFormat, NumericFormatProps } from 'react-number-format'

interface InputProps extends NumericFormatProps {
  onChange: (event: { target: { name: string; value: string } }) => void
  name: string
}

const NumericFormatInput = React.forwardRef(
  (props: InputProps, ref?: React.Ref<any>) => {
    const { onChange, ...rest } = props

    return (
      <NumericFormat
        {...rest}
        getInputRef={ref}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props.name,
              value: values.value,
            },
          })
        }}
      />
    )
  },
)

export const NumericField = React.forwardRef(
  (props: TextFieldProps, ref?: React.Ref<any>) => {
    const { inputProps, InputProps, ...rest } = props

    return (
      <TextField
        variant="outlined"
        size="small"
        inputRef={ref}
        InputProps={{
          ...InputProps,
          inputComponent: NumericFormatInput as any,
          inputProps,
        }}
        {...rest}
      />
    )
  },
)
